import security from "@/main";
import { getApiBaseUrl } from "@/config";
import { filenameFrom } from "@/modules/core/service/private/Filename";

const resolve = (url) => url.startsWith("http://") || url.startsWith("https://") ? url : getApiBaseUrl() + url;

const handleResponse = function (response) {
    if (!response.ok) {
        if (response.status === 401) {
            this.logout();
        } else {
            return response.json().then (message => {
                return Promise.reject (message);
            })
        }

        return Promise.reject();
    }

    return response.blob().then(blob => {
        const filename = filenameFrom(response, "download");
        const data = new Blob([blob], {type: response.headers.get("Content-Type")});
        const url =  URL.createObjectURL(data);
        let link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        return Promise.resolve();
    })
}

export default {
    perform (url, body) {
        return fetch(resolve(url), {
            method : "POST",
            headers: security.jsonHeader(),
            body   : JSON.stringify(body)
        })
            .then(response => {
                return handleResponse (response);
            })
            .catch(e => {
                return Promise.reject(e)
            });
    },

}